import React, {Component} from 'react';
import axios from 'axios';
import CryptoCurrency from './CryptoCurrency';
import Error from './Error';

class Form extends Component {
   
    state = {
        cryptoCurrencies: [],
        currency: '',
        cryptocurrency: '',
        error: false
    }

    async componentWillMount(){
        const url = `https://min-api.cryptocompare.com/data/top/totalvolfull?limit=10&tsym=USD`
        await axios.get(url)
              .then(res => {
                  this.setState({
                    cryptoCurrencies: res.data.Data
                  })
              })  
    }

    getValue = e => {
        const {name, value} = e.target
        this.setState({
            [name]: value
        })
    }

    quoteCurrency = e => {
        e.preventDefault()

        const {currency, cryptoCurrency} = this.state

        if(currency === '' || cryptoCurrency === ''){
            this.setState({
                error: true
            }, () => {
                setTimeout(() => {
                    this.setState({
                        error: false
                    })
                }, 3000)
            }) 
            return;
        }

        const quoting = {
            currency,
            cryptoCurrency
        }

        this.props.quoteCryptoCurrency(quoting)
    }

    render(){

        const messageError = this.state.error ? <Error message="Ambos campos son obligatorios" /> : ''

        return(
            <form onSubmit={this.quoteCurrency}>
                {messageError}
                <div className="row">
                    <label>Elige tu Moneda</label>
                    <select
                        onChange={this.getValue} 
                        name="currency"
                        className="u-full-width">
                            <option value="">Elige tu moneda</option>
                            <option value="USD">Dolar Estadounidense</option>
                            <option value="COP">Pesos Colombiano</option>
                            <option value="GBP">Libras</option>
                            <option value="EUR">Euros</option>
                    </select>
                </div>

                <div className="row">
                <div>
                    <label>Elige tu Criptomoneda</label>
                    <select
                        onChange={this.getValue} 
                        name="cryptoCurrency" 
                        className="u-full-width">
                        <option value="">Elige tu moneda</option>
                        {this.state.cryptoCurrencies.map((cryptoCurrency, index) =>(
                            <CryptoCurrency
                            cryptoCurrency={cryptoCurrency}
                            key={index}
                        />
                        ))}
                    </select>
                </div>
                </div>
                <input className="button-primary u-full-width" type="submit" value="Cotizar" />
            </form>
        )
    }
}

export default Form